import { Card } from "reactstrap";
import EmployeeCardHeader from "../EmployeeCardHeader";
import EmployeeDetailsPanel from "../EmployeeDetailsPanel";

export interface EmployeeInfoCardProps<T extends object> {
  // header
  title?: string;
  headClass?: string;
  titleClass?: string;
  iconClassName?: string;
  iconOnClick?: () => void;

  // body (object or array)
  entity: T | T[];

  // details options
  fieldOrder?: (keyof T | string)[];
  labelMap?: Partial<Record<keyof T | string, string>>;
  formatters?: Parameters<typeof EmployeeDetailsPanel<T>>[0]["formatters"];
  omitKeys?: (keyof T | string)[];
  bodyClassName?: string;

  // array options
  gridColumns?: 1 | 2 | 3 | 4;
  getItemTitle?: (item: T, index: number) => React.ReactNode;
  getItemKey?: (item: T, index: number) => React.Key;
  itemClassName?: string;
  itemColMd?: 12 | 6 | 4 | 3;
  fieldActions?: Partial<Record<keyof T | string, () => void>>;
  canEdit?: boolean;
  showEditInfo?: boolean;
  previewableKeys?: (keyof T | string)[]; // 👈 new
  onPreview?: (key: keyof T | string, value: unknown) => void; // 👈 new
}

const EmployeeInfoCard = <T extends object>({
  headClass = "b-l-primary border-3",
  titleClass = "f-w-400 f-14",
  title = "",
  iconClassName = "fa fa-edit pointer f-20",
  iconOnClick = () => {},

  entity,
  fieldOrder,
  labelMap,
  formatters,
  omitKeys,
  bodyClassName,

  gridColumns,
  getItemTitle,
  getItemKey,
  itemClassName,
  itemColMd,
  fieldActions,
  canEdit,
  onPreview,
  showEditInfo,
  previewableKeys,
}: EmployeeInfoCardProps<T>) => {
  return (
    <Card>
      <EmployeeCardHeader
        headClass={headClass}
        title={title}
        titleClass={titleClass}
        iconClassName={iconClassName}
        iconOnClick={iconOnClick}
        showEditInfo={showEditInfo}
      />
      <EmployeeDetailsPanel<T>
        className={bodyClassName}
        entity={entity}
        fieldOrder={fieldOrder}
        labelMap={labelMap}
        formatters={formatters}
        omitKeys={omitKeys}
        gridColumns={gridColumns}
        getItemTitle={getItemTitle}
        getItemKey={getItemKey}
        itemClassName={itemClassName}
        itemColMd={itemColMd}
        fieldActions={fieldActions}
        canEdit={canEdit}
        onPreview={onPreview}
        previewableKeys={previewableKeys}
      />
    </Card>
  );
};

export default EmployeeInfoCard;
